import { getAxiosInstance } from '../blocks/axios/axiosFactory';
import GetPenaltyRequest from '../models/penalty/GetPenaltyRequest';

const url = "/offence";

export default class OffenceService {
    static getPenalty(request: GetPenaltyRequest) {
        return getAxiosInstance().get(`${url}/get/${encodeURIComponent(request.referenceNumber)}`, { suppressErrorToast: true } as any);
    }
}
